import { render, staticRenderFns } from "./GradingReports.vue?vue&type=template&id=3511f37a&scoped=true&"
import script from "./GradingReports.vue?vue&type=script&lang=js&"
export * from "./GradingReports.vue?vue&type=script&lang=js&"
import style0 from "./GradingReports.vue?vue&type=style&index=0&id=3511f37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3511f37a",
  null
  
)

export default component.exports